import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter, Route, Routes, Navigate } from "react-router-dom";

import "assets/plugins/nucleo/css/nucleo.css";
import "@fortawesome/fontawesome-free/css/all.min.css";
import "assets/scss/argon-dashboard-react.scss";

import AdminLayout from "layouts/Admin.js";
import AuthLayout from "layouts/Auth.js";

// Importa o PrivateRoute para proteger as rotas
import PrivateRoute from "routes/PrivateRoute";

// Configuração Global do Axios (Interceptor para erro 401)
import setupAxiosInterceptors from "services/setupAxios";
setupAxiosInterceptors();

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <BrowserRouter>
    <Routes>
      {/* Protege as rotas do AdminLayout */}
      <Route
        path="/admin/*"
        element={
          <PrivateRoute>
            <AdminLayout />
          </PrivateRoute>
        }
      />
      {/* Rotas de autenticação (login, registro) não precisam de proteção */}
      <Route path="/auth/*" element={<AuthLayout />} />
      {/* Redireciona rotas desconhecidas para a página inicial do admin */}
      <Route path="*" element={<Navigate to="/admin/index" replace />} />
    </Routes>
  </BrowserRouter>
);
